import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BinarySelectOption } from '../../models/binary-select-option.model';
import { fieldIsRequired } from '../../utils/forms.utils';

@Component({
  selector: 'app-binary-input',
  templateUrl: './binary-input.component.html',
  styleUrl: './binary-input.component.scss',
})
export class BinaryInputComponent {
  @Input({ required: true }) control!: FormControl<number>;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) options!: BinarySelectOption[];

  isRequired = fieldIsRequired;
}
